import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './AdminLogin.css'
import LogoImg from '../images/morecharz-logo.webp'

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

const graphqlRequest = async (query, variables) => {
  const response = await fetch(`${apiBaseUrl}/graphql`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, variables }),
  })
  const result = await response.json()
  if (!response.ok || result.errors?.length) throw new Error(result.errors?.[0]?.message || 'Unable to sign in')
  return result.data
}

function AdminLogin({ onLogin }) {
  const [phone, setPhone] = useState('')
  const [otp, setOtp] = useState('')
  const [step, setStep] = useState('phone')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const requestOtp = async (event) => {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const data = await graphqlRequest(
        'mutation RequestOtp($phone: String!) { requestOtp(phone: $phone) { success message otpDebug } }',
        { phone: phone.replace(/\D/g, '') },
      )
      const result = data.requestOtp
      if (!result.success) throw new Error(result.message)
      setMessage(result.otpDebug ? `${result.message} Development OTP: ${result.otpDebug}` : result.message)
      setStep('otp')
    } catch (requestError) {
      setError(requestError.message)
    } finally {
      setBusy(false)
    }
  }

  const verifyOtp = async (event) => {
    event.preventDefault()
    setBusy(true)
    setError('')
    try {
      const data = await graphqlRequest(
        'mutation VerifyOtp($phone: String!, $otp: String!) { verifyOtp(phone: $phone, otp: $otp) { success message token user { id phone name email role } } }',
        { phone: phone.replace(/\D/g, ''), otp: otp.trim() },
      )
      const result = data.verifyOtp
      if (!result.success || !result.token) throw new Error(result.message || 'Unable to sign in')
      if (String(result.user?.role || '').toLowerCase() !== 'admin') throw new Error('Admin access required')
      onLogin(result.token)
    } catch (verifyError) {
      setError(verifyError.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="admin-login-page">
      <section className="admin-login-panel">
        <section className="logo-section">
          <img src={LogoImg} alt="MoRecharz" className="logo-img" />
        </section>
        <p className="eyebrow">PRIVATE ADMIN ACCESS</p>
        <h1>Admin Center</h1>
        <p className="admin-login-subtitle">Sign in with your admin account for MoRecharz.<br/>Are you a Customer? <a href="https://www.morecharz.com">Click here</a>.</p>
        {step === 'phone' ? (
          <form onSubmit={requestOtp}>
            <label htmlFor="admin-phone">Admin phone number</label>
            <input id="admin-phone" value={phone} onChange={(event) => setPhone(event.target.value)} placeholder="10-digit phone number" inputMode="tel" autoComplete="tel" required />
            <button className="admin-login-submit" type="submit" disabled={busy}>{busy ? 'Sending...' : 'Send OTP'}</button>
          </form>
        ) : (
          <form onSubmit={verifyOtp}>
            <label htmlFor="admin-otp">Verification code</label>
            <input id="admin-otp" value={otp} onChange={(event) => setOtp(event.target.value)} placeholder="6-digit OTP" inputMode="numeric" autoComplete="one-time-code" maxLength={6} required />
            <button className="admin-login-submit" type="submit" disabled={busy}>{busy ? 'Checking...' : 'Enter workspace'}</button>
            <button className="admin-login-back" type="button" onClick={() => { setStep('phone'); setMessage(''); setError('') }}>Use a different number</button>
          </form>
        )}
        {message && <p className="admin-login-message">{message}</p>}
        {error && <p className="admin-login-error">{error}</p>}
      </section>
    </main>
  )
}

export default AdminLogin
